// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  /* KPI tiles */
  /* panels */
  /* week planner */
  /* lists */
}
.dashboard .muted {
  color: #64748b;
  font-size: 0.8rem;
  margin: 2px 0 0;
}
.dashboard .dash-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}
.dashboard .dash-head h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0f172a;
}
.dashboard .dash-head .muted {
  text-transform: capitalize;
  font-size: 0.9rem;
}
.dashboard .dash-actions {
  display: flex;
  gap: 8px;
}
.dashboard .kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}
.dashboard .kpi {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.dashboard .kpi > i {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 1.15rem;
}
.dashboard .kpi .kpi-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}
.dashboard .kpi strong {
  font-size: 1.75rem;
  line-height: 1.2;
  color: #0f172a;
}
.dashboard .kpi.arrivals > i {
  background: #ccfbf1;
  color: #0f766e;
}
.dashboard .kpi.departures > i {
  background: #fef3c7;
  color: #b45309;
}
.dashboard .kpi.inhouse > i {
  background: #dbeafe;
  color: #1d4ed8;
}
.dashboard .kpi.pending > i {
  background: #fee2e2;
  color: #b91c1c;
}
.dashboard .panel {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
  margin-bottom: 18px;
  overflow: hidden;
}
.dashboard .panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #eef0f3;
}
.dashboard .panel-head h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}
.dashboard .see-all {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f766e;
  cursor: pointer;
  text-decoration: none;
}
.dashboard .see-all:hover {
  text-decoration: underline;
}
.dashboard .week-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dashboard .week-nav .week-range {
  margin-right: 6px;
  font-size: 0.85rem;
  color: #64748b;
}
.dashboard .nav-btn {
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 7px;
  font: inherit;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}
.dashboard .nav-btn:hover {
  background: #f1f5f9;
}
.dashboard .week {
  display: grid;
  grid-template-columns: repeat(7, minmax(130px, 1fr));
  overflow-x: auto;
}
.dashboard .week-col {
  min-height: 190px;
  border-right: 1px solid #eef0f3;
}
.dashboard .week-col:last-child {
  border-right: 0;
}
.dashboard .week-col.today {
  background: #f0fdfa;
}
.dashboard .week-day {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid #eef0f3;
  background: #f9fafb;
}
.dashboard .week-day span {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}
.dashboard .week-day strong {
  font-size: 1.1rem;
  color: #0f172a;
}
.dashboard .week-day em {
  margin-left: auto;
  font-style: normal;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 4px;
  background: #ccfbf1;
  color: #0f766e;
}
.dashboard .week-col.today .week-day {
  background: #0f766e;
}
.dashboard .week-col.today .week-day span {
  color: #99f6e4;
}
.dashboard .week-col.today .week-day strong {
  color: #ffffff;
}
.dashboard .week-col.today .week-day em {
  background: #ffffff;
}
.dashboard .week-events {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
}
.dashboard .week-empty {
  color: #cbd5e1;
  text-align: center;
  padding-top: 12px;
}
.dashboard .event {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #14b8a6;
  border-radius: 6px;
  font: inherit;
  cursor: pointer;
  transition: box-shadow 0.12s, transform 0.12s;
}
.dashboard .event:hover {
  box-shadow: 0 6px 14px -8px rgba(15, 23, 42, 0.4);
  transform: translateY(-1px);
}
.dashboard .event .event-guest {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f172a;
}
.dashboard .event .event-room {
  font-size: 0.78rem;
  color: #475569;
}
.dashboard .event .event-meta {
  font-size: 0.72rem;
  color: #94a3b8;
}
.dashboard .dash-cols {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}
.dashboard .dash-table .p-datatable-tbody > tr > td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.dashboard .dash-table .p-datatable-tbody > tr:last-child > td {
  border-bottom: 0;
}
.dashboard .guest-name {
  font-weight: 600;
  color: #0f172a;
}
.dashboard .price {
  font-weight: 700;
  white-space: nowrap;
}
.dashboard .action {
  text-align: right;
  white-space: nowrap;
  width: 1%;
}
.dashboard .action .p-button + .p-button {
  margin-left: 0.4rem;
}
.dashboard .empty {
  text-align: center;
  padding: 1.75rem 1rem !important;
  color: #64748b;
}
@media (max-width: 991px) {
  .dashboard .dash-cols {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=admin-dashboard.component.css.map */`, "",{"version":3,"sources":["webpack://./admin-dashboard.component.less","webpack://./src/app/admin-dashboard/admin-dashboard.component.less"],"names":[],"mappings":"AAEA;ECDE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;ADHA;EAEI,cAAA;EACA,iBAAA;EACA,eAAA;ACIJ;ADRA;EAQI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACGJ;ADhBA;EAgBM,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;ACGN;ADvBA;EAwBM,0BAAA;EACA,iBAAA;ACEN;AD3BA;EA8BI,aAAA;EACA,QAAA;ACAJ;AD/BA;EAoCI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;ACFJ;ADrCA;EA2CI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;ACHJ;AD/CA;EAqDM,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;ACHN;ADxDA;EA+DM,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;ACJN;ADhEA;EAwEM,kBAAA;EACA,gBAAA;EACA,cAAA;ACLN;ADQI;EAAiB,mBAAA;EAAqB,cAAA;ACJ1C;ADKI;EAAmB,mBAAA;EAAqB,cAAA;ACD5C;ADEI;EAAgB,mBAAA;EAAqB,cAAA;ACEzC;ADDI;EAAgB,mBAAA;EAAqB,cAAA;ACKzC;ADrFA;EAqFI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;EACA,mBAAA;EACA,gBAAA;ACGJ;AD7FA;EA8FI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACEJ;ADrGA;EAsGM,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ACEN;AD3GA;EA8GI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;ACAJ;ADEI;EAAU,0BAAA;ACCd;ADrHA;EAwHI,aAAA;EACA,mBAAA;EACA,QAAA;ACAJ;AD1HA;EA6HM,iBAAA;EACA,kBAAA;EACA,cAAA;ACAN;AD/HA;EAoII,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ACFJ;ADII;EAAU,mBAAA;ACDd;AD7IA;EAmJI,aAAA;EACA,oDAAA;EACA,gBAAA;ACHJ;ADlJA;EAyJI,iBAAA;EACA,+BAAA;ACJJ;ADMI;EAAe,eAAA;ACHnB;ADII;EAAU,mBAAA;ACDd;AD5JA;EAiKI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;ACFJ;ADpKA;EAyKM,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;ACFN;AD3KA;EAiLM,iBAAA;EACA,cAAA;ACHN;AD/KA;EAsLM,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ACJN;ADzLA;EAkMI,mBAAA;ACNJ;AD5LA;EAoMW,cAAA;ACLX;AD/LA;EAqMa,cAAA;ACHb;ADlMA;EAsMS,mBAAA;ACDT;ADrMA;EA0MI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ACFJ;AD3MA;EAiNI,cAAA;EACA,kBAAA;EACA,iBAAA;ACHJ;ADhNA;EAuNI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6CAAA;ACJJ;ADMI;EACE,iDAAA;EACA,2BAAA;ACJN;ADnOA;EA0OmB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;ACFzD;ADxOA;EA2OkB,kBAAA;EAAoB,cAAA;ACCtC;AD5OA;EA4OkB,kBAAA;EAAoB,cAAA;ACItC;ADhPA;EAiPI,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;ACEJ;ADtPA;EAyPM,qBAAA;EACA,gCAAA;EACA,sBAAA;ACAN;AD3PA;EA8P8C,gBAAA;ACA9C;AD9PA;EAiQgB,gBAAA;EAAkB,cAAA;ACClC;ADlQA;EAkQW,gBAAA;EAAkB,mBAAA;ACI7B;ADtQA;EAmQY,iBAAA;EAAmB,mBAAA;EAAqB,SAAA;ACQpD;AD3QA;EAoQkC,mBAAA;ACUlC;AD9QA;EAqQW,kBAAA;EAAoB,gCAAA;EAAkC,cAAA;ACcjE;ADXA;EACE;IAAwB,0BAAA;ECcxB;AACF;AACA,wDAAwD","sourcesContent":["@import (reference) \"../../assets/less/colors.less\";\n\n.dashboard {\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n    margin: 2px 0 0;\n  }\n\n  .dash-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 18px;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 700;\n      letter-spacing: -0.01em;\n      color: #0f172a;\n    }\n\n    .muted {\n      text-transform: capitalize;\n      font-size: 0.9rem;\n    }\n  }\n\n  .dash-actions {\n    display: flex;\n    gap: 8px;\n  }\n\n  /* KPI tiles */\n  .kpis {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 14px;\n    margin-bottom: 18px;\n  }\n\n  .kpi {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 16px 18px;\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n\n    > i {\n      width: 44px;\n      height: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 10px;\n      font-size: 1.15rem;\n    }\n\n    .kpi-label {\n      display: block;\n      font-size: 0.72rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: #64748b;\n    }\n\n    strong {\n      font-size: 1.75rem;\n      line-height: 1.2;\n      color: #0f172a;\n    }\n\n    &.arrivals > i { background: #ccfbf1; color: #0f766e; }\n    &.departures > i { background: #fef3c7; color: #b45309; }\n    &.inhouse > i { background: #dbeafe; color: #1d4ed8; }\n    &.pending > i { background: #fee2e2; color: #b91c1c; }\n  }\n\n  /* panels */\n  .panel {\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n    margin-bottom: 18px;\n    overflow: hidden;\n  }\n\n  .panel-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 18px;\n    border-bottom: 1px solid #eef0f3;\n\n    h3 {\n      margin: 0;\n      font-size: 1rem;\n      font-weight: 700;\n      color: #0f172a;\n    }\n  }\n\n  .see-all {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #0f766e;\n    cursor: pointer;\n    text-decoration: none;\n\n    &:hover { text-decoration: underline; }\n  }\n\n  .week-nav {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    .week-range {\n      margin-right: 6px;\n      font-size: 0.85rem;\n      color: #64748b;\n    }\n  }\n\n  .nav-btn {\n    height: 34px;\n    padding: 0 12px;\n    border: 1px solid #e5e7eb;\n    background: @white;\n    border-radius: @radius;\n    font: inherit;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n\n    &:hover { background: #f1f5f9; }\n  }\n\n  /* week planner */\n  .week {\n    display: grid;\n    grid-template-columns: repeat(7, minmax(130px, 1fr));\n    overflow-x: auto;\n  }\n\n  .week-col {\n    min-height: 190px;\n    border-right: 1px solid #eef0f3;\n\n    &:last-child { border-right: 0; }\n    &.today { background: #f0fdfa; }\n  }\n\n  .week-day {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    padding: 10px 12px;\n    border-bottom: 1px solid #eef0f3;\n    background: #f9fafb;\n\n    span {\n      font-size: 0.72rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: #94a3b8;\n    }\n\n    strong {\n      font-size: 1.1rem;\n      color: #0f172a;\n    }\n\n    em {\n      margin-left: auto;\n      font-style: normal;\n      font-size: 0.72rem;\n      font-weight: 700;\n      padding: 1px 7px;\n      border-radius: 4px;\n      background: #ccfbf1;\n      color: #0f766e;\n    }\n  }\n\n  .week-col.today .week-day {\n    background: #0f766e;\n\n    span { color: #99f6e4; }\n    strong { color: @white; }\n    em { background: @white; }\n  }\n\n  .week-events {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 8px;\n  }\n\n  .week-empty {\n    color: #cbd5e1;\n    text-align: center;\n    padding-top: 12px;\n  }\n\n  .event {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 100%;\n    padding: 8px 10px;\n    text-align: left;\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-left: 3px solid #14b8a6;\n    border-radius: 6px;\n    font: inherit;\n    cursor: pointer;\n    transition: box-shadow 0.12s, transform 0.12s;\n\n    &:hover {\n      box-shadow: 0 6px 14px -8px rgba(15, 23, 42, 0.4);\n      transform: translateY(-1px);\n    }\n\n    .event-guest { font-size: 0.85rem; font-weight: 600; color: #0f172a; }\n    .event-room { font-size: 0.78rem; color: #475569; }\n    .event-meta { font-size: 0.72rem; color: #94a3b8; }\n  }\n\n  /* lists */\n  .dash-cols {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 18px;\n    align-items: start;\n  }\n\n  .dash-table {\n    .p-datatable-tbody > tr > td {\n      padding: 0.75rem 1rem;\n      border-bottom: 1px solid #f1f5f9;\n      vertical-align: middle;\n    }\n\n    .p-datatable-tbody > tr:last-child > td { border-bottom: 0; }\n  }\n\n  .guest-name { font-weight: 600; color: #0f172a; }\n  .price { font-weight: 700; white-space: nowrap; }\n  .action { text-align: right; white-space: nowrap; width: 1%; }\n  .action .p-button + .p-button { margin-left: 0.4rem; }\n  .empty { text-align: center; padding: 1.75rem 1rem !important; color: #64748b; }\n}\n\n@media (max-width: 991px) {\n  .dashboard .dash-cols { grid-template-columns: 1fr; }\n}\n",".dashboard {\n  /* KPI tiles */\n  /* panels */\n  /* week planner */\n  /* lists */\n}\n.dashboard .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n  margin: 2px 0 0;\n}\n.dashboard .dash-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.dashboard .dash-head h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n}\n.dashboard .dash-head .muted {\n  text-transform: capitalize;\n  font-size: 0.9rem;\n}\n.dashboard .dash-actions {\n  display: flex;\n  gap: 8px;\n}\n.dashboard .kpis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n.dashboard .kpi {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 18px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.dashboard .kpi > i {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  font-size: 1.15rem;\n}\n.dashboard .kpi .kpi-label {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n.dashboard .kpi strong {\n  font-size: 1.75rem;\n  line-height: 1.2;\n  color: #0f172a;\n}\n.dashboard .kpi.arrivals > i {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n.dashboard .kpi.departures > i {\n  background: #fef3c7;\n  color: #b45309;\n}\n.dashboard .kpi.inhouse > i {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.dashboard .kpi.pending > i {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n.dashboard .panel {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n  margin-bottom: 18px;\n  overflow: hidden;\n}\n.dashboard .panel-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #eef0f3;\n}\n.dashboard .panel-head h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n.dashboard .see-all {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #0f766e;\n  cursor: pointer;\n  text-decoration: none;\n}\n.dashboard .see-all:hover {\n  text-decoration: underline;\n}\n.dashboard .week-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dashboard .week-nav .week-range {\n  margin-right: 6px;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n.dashboard .nav-btn {\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 7px;\n  font: inherit;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n}\n.dashboard .nav-btn:hover {\n  background: #f1f5f9;\n}\n.dashboard .week {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(130px, 1fr));\n  overflow-x: auto;\n}\n.dashboard .week-col {\n  min-height: 190px;\n  border-right: 1px solid #eef0f3;\n}\n.dashboard .week-col:last-child {\n  border-right: 0;\n}\n.dashboard .week-col.today {\n  background: #f0fdfa;\n}\n.dashboard .week-day {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #eef0f3;\n  background: #f9fafb;\n}\n.dashboard .week-day span {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n}\n.dashboard .week-day strong {\n  font-size: 1.1rem;\n  color: #0f172a;\n}\n.dashboard .week-day em {\n  margin-left: auto;\n  font-style: normal;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 1px 7px;\n  border-radius: 4px;\n  background: #ccfbf1;\n  color: #0f766e;\n}\n.dashboard .week-col.today .week-day {\n  background: #0f766e;\n}\n.dashboard .week-col.today .week-day span {\n  color: #99f6e4;\n}\n.dashboard .week-col.today .week-day strong {\n  color: #ffffff;\n}\n.dashboard .week-col.today .week-day em {\n  background: #ffffff;\n}\n.dashboard .week-events {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px;\n}\n.dashboard .week-empty {\n  color: #cbd5e1;\n  text-align: center;\n  padding-top: 12px;\n}\n.dashboard .event {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  padding: 8px 10px;\n  text-align: left;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-left: 3px solid #14b8a6;\n  border-radius: 6px;\n  font: inherit;\n  cursor: pointer;\n  transition: box-shadow 0.12s, transform 0.12s;\n}\n.dashboard .event:hover {\n  box-shadow: 0 6px 14px -8px rgba(15, 23, 42, 0.4);\n  transform: translateY(-1px);\n}\n.dashboard .event .event-guest {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n.dashboard .event .event-room {\n  font-size: 0.78rem;\n  color: #475569;\n}\n.dashboard .event .event-meta {\n  font-size: 0.72rem;\n  color: #94a3b8;\n}\n.dashboard .dash-cols {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  align-items: start;\n}\n.dashboard .dash-table .p-datatable-tbody > tr > td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n.dashboard .dash-table .p-datatable-tbody > tr:last-child > td {\n  border-bottom: 0;\n}\n.dashboard .guest-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n.dashboard .price {\n  font-weight: 700;\n  white-space: nowrap;\n}\n.dashboard .action {\n  text-align: right;\n  white-space: nowrap;\n  width: 1%;\n}\n.dashboard .action .p-button + .p-button {\n  margin-left: 0.4rem;\n}\n.dashboard .empty {\n  text-align: center;\n  padding: 1.75rem 1rem !important;\n  color: #64748b;\n}\n@media (max-width: 991px) {\n  .dashboard .dash-cols {\n    grid-template-columns: 1fr;\n  }\n}\n/*# sourceMappingURL=admin-dashboard.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
